import { useRouter } from 'next/router';
import React from 'react';
import { PATH_NAME } from '../../configs/pathName';
import { IPrimaryBtn } from '../../interfaces/components/button.interface';

const PrimaryBtn: React.FC<IPrimaryBtn> = ({
  children,
  callback,
  classname,
  disabled = false,
}) => {
  const handleClick = () => {
    callback && callback();
  };
  let btnInLandingPage = false;
  const router = useRouter();

  if (router.pathname === PATH_NAME.HOMEPAGE) {
    btnInLandingPage = true;
  }
  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={`${classname} ${
        btnInLandingPage
          ? 'bg-green hover:bg-green_hover'
          : 'bg-primary__gradient'
      } text-white text-md font-semibold text-center w-full rounded-lg py-4`}
    >
      {children}
    </button>
  );
};

export default PrimaryBtn;
